<script>
import vFormRender from "./vFormRender.vue";
export default {
  name: "VFormRenderPreview",
  extends: vFormRender,
  data() {
    return { previewState: true };
  }
};
</script>
